<template>
  <avz-apl-map :aplid="aplid" />
</template>

<script>
import APLMap from '@/components/APLMap'

export default {
  name: 'APLMap',
  components: {
    'avz-apl-map': APLMap
  },

  data: () => ({
    aplid: null
  }),

  created () {
    this.aplid = this.$route.params.id
  }
}
</script>
